if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-regression/~/ml-matrix/src/symbol-species.js
// module id = 233
// module chunks = 0